declare global {
  interface Window {
    dataLayer: unknown[];
  }
}

export function initGTM(id?: string) {
  if (!id) return;
  try {
    // Initialize dataLayer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

    // Insert script
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${id}`;
    document.head.appendChild(script);

    // Insert noscript iframe at top of body
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${id}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
    document.addEventListener('DOMContentLoaded', () => {
      if (document.body && !document.body.querySelector('noscript[data-gtm-inserted]')) {
        noscript.setAttribute('data-gtm-inserted', 'true');
        document.body.insertBefore(noscript, document.body.firstChild);
      }
    });
  } catch (e) {
    // swallow errors to avoid breaking app if GTM fails
    console.error('GTM initialization failed:', e);
    console.warn('initGTM error', e);
  }
}
